export default {
  login: {
    title: 'login',
    type: 'object',
    properties: {
      email: {
        type: 'string',
        format: 'email',
      },
      password: {
        type: 'string',
        minLength: 12,
      },
    },
    required: ['email', 'password'],
  },
  recover_password: {
    title: 'recover_password',
    type: 'object',
    properties: {
      email: {
        type: 'string',
        format: 'email',
      },
    },
    required: ['email'],
  },
  reset_password: {
    title: 'recover_password',
    type: 'object',
    properties: {
      password: {
        type: 'string',
        minLength: 12,
      },
    },
    required: ['password'],
  },
};

export const completeInfo = {
  title: 'complete_info',
  type: 'object',
  properties: {
    name: {
      type: 'string',
      minLength: 1,
    },
    lastname: {
      type: 'string',
      minLength: 1,
    },
    password: {
      type: 'string',
      minLength: 12,
    },
  },
};



// WEBPACK FOOTER //
// src/lib/schemas/auth_schemas.js